export { phoneNumberRegex } from "shared/utils";

const HELPSCOUT_EMAIL = "help@whereabouts.tech";

export { HELPSCOUT_EMAIL };
